<template lang="html">
  <div class="wps-template-item" @click="$emit('toPage', item.id, fileName)">
    <div>
      <img v-if="$route.path==='/wps-template/list'" src="./images/icon-file.png" alt="">
      <img v-else :src="image" alt="">
    </div>
    <div class="main">
      <p>{{fileName}}</p>
      <div>
        <span v-if="size">{{fileSize}}</span>
        <span>{{date}}</span>
      </div>
    </div>
    <div>
      <p class="add-file" v-if="$route.path === '/wps-template/detail'">领取</p>
      <img v-else class="icon-right" src="./images/icon-right.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'Item',
  props: ['item', 'lastModified', 'fileName', 'size'],
  computed: {
    date () {
      if (this.lastModified) {
        let date = new Date(this.lastModified)
        return moment(date).format('YYYY-MM-DD HH:mm')
      }
      return ''
    },
    image () {
      let arr = this.fileName.split('.')
      let fileType = (arr[arr.length - 1]).toLowerCase() || ''

      if (fileType.indexOf('ppt') > -1) {
        return require('./images/icon-ppt.png')
      } else if (fileType.indexOf('doc') > -1 || fileType.indexOf('pdf') > -1) {
        return require('./images/icon-doc.png')
      } else if (fileType.indexOf('xl') > -1 || fileType.indexOf('csv') > -1) {
        return require('./images/icon-xls.png')
      } else {
        return require('./images/icon-default.png')
      }
    },
    fileSize () {
      if (this.size < 1024) {
        return `${this.size}kb`
      } else {
        return `${(this.size/1024).toFixed(2)}m`
      }
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.wps-template-item {
  padding: rem(20) rem(30);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: rem(1) solid #e4e4e4;
  img {
    width: rem(56);
  }
  .icon-right {
    width: rem(12);
  }
  .main {
    line-height: 1.4;
    width: rem(510);
    p {
      font-size: rem(28);
      color: #333;
    }
    span  {
      font-size: rem(24);
      color: #999999;
      display: inline-block;
      margin-right: rem(15);
    }
  }
  .add-file {
    color: #F49001;
    border-radius: rem(5);
    font-size: rem(24);
  }
}
</style>
